var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.167 11.667l12.5-9.667 40.333 47.167-2.5 8.833-50.333-46.333z",
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.833 3.5l15.167 10.333-43 39.333-15.5 3.5L46.833 3.5z",
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f40a99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 10.167l12.833-9.167 41 48-.5 9.5-53.333-48.333z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 3c4.278 3.5 8.556 7 12.833 10.5L16.833 51.5 2.833 56.5 46 3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.333s-10 5.667-10 6.667 8 8 8 8-3-3-3-6 5-8.667 5-8.667z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.333 53.333l18.667-21.333s-9 13.5-9 16-9.667 5.333-9.667 5.333z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.667 5.333l-6.667 6.667s5.5-4 10-2-3.333-4.667-3.333-4.667z",
    fill: "#C8C8C8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.0fe430e8efefec2068bcd93f7edefb60.svg";
export { ForwardRef as ReactComponent };